import React from 'react';
import { Box } from '@mui/material';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './HeroSection';
import TrustSection from './TrustSection';
import ServicesSection from './ServicesSection';
import HowItWorksSection from './HowItWorksSection';
import QuickOrderSection from '../../components/home/QuickOrderSection';

const HomePage: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Header />
      
      {/* Hero Section - No container padding */}
      <HeroSection />
      
      {/* Other sections with normal layout */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        <ServicesSection />
        <TrustSection />
        <HowItWorksSection />
        <QuickOrderSection />
      </Box>
      
      <Footer />
    </Box>
  );
};

export default HomePage; 